import { render, staticRenderFns } from "./ComplaintsReportFilter.vue?vue&type=template&id=fd86496c&"
import script from "./ComplaintsReportFilter.vue?vue&type=script&lang=js&"
export * from "./ComplaintsReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports